//READY ... GO!
document.addEventListener("DOMContentLoaded", function () {



    // Appel de la gestion de cookies RGPD
    jQuery(".cookie").on("click", function(e){
        e.preventDefault();
        if( typeof openAxeptioCookies === 'function' ) {
            openAxeptioCookies();
        }
    });


    /*=============================================>>>>>
    = Fixed menu =
    ===============================================>>>>>*/
    function stickyNavbar() {
        const observeScroll = document.body.classList.contains('page-accueil') || document.body.classList.contains('page-trouver-son-vehicule');
        if (observeScroll) {
            if (document.documentElement.scrollTop > 0) {
                document.body.classList.add('is-scrolled');
            } else {
                document.body.classList.remove('is-scrolled');
            }
        }
    }

    // window.onclick = function (event) {
    //     if (!event.target.matches(".navbar-toggler")) {
    //         let menuToHide = document.querySelector("#navbarNavDropdown");
    //         if (menuToHide.classList.contains("show")) {
    //             menuToHide.classList.remove("show");
    //         }
    //     }
    // };

    /*=============================================>>>>>
    = Lazyload =
    ===============================================>>>>>*/
    let lazyLoadInstance = new LazyLoad({
        // Your custom settings go here
    });

    /*=============================================>>>>>
    = Megamenu  =
    ===============================================>>>>>*/
    function removeShowDropdownMenuOnSCroll() {
        let dropdownMenu = document.querySelector(".dropdown-menu");
        if (dropdownMenu.classList.contains("show")) {
            dropdownMenu.classList.remove("show");
        }
    }

    //Sous menu mobile
    //Lorsqu'on clique sur les sous menus de niveau 2 du bloc "Services"
    jQuery(".menu-depth-2").children("a.dropdown-item").on("click", function (e) {
        e.stopPropagation();
        // Hide all submenu
        jQuery('.menu-depth-2').children('.dropdown-menu').removeClass('show')
        // Show targetted
        jQuery(this).next().addClass('show');
    });

    /*=============================================>>>>>
    = Etablissements =
    ===============================================>>>>>*/

    function etablissementsCollapse() {
        //lorient
        let lorientPin = document.querySelector("#lorient-pin-fill,#Lorient");
        let lorientListe = document.querySelector("#lorient-liste");
        let lorientClose = document.querySelector("#lorient-close");

        // Vannes
        let vannesPin = document.querySelector("#vannes-pin-fill,#Vannes");
        let vannesListe = document.querySelector("#vannes-liste");
        let vannesClose = document.querySelector("#vannes-close");

        // Auray
        let aurayPin = document.querySelector("#auray-pin-fill,#Auray");
        let aurayListe = document.querySelector("#auray-liste");
        let aurayClose = document.querySelector("#auray-close");

        //lorient
        lorientPin.addEventListener("click", function () {
            lorientListe.classList.toggle("etablissement-visible");
            if (vannesListe.classList.contains("etablissement-visible")) {
                vannesListe.classList.remove("etablissement-visible");
            }
            if (aurayListe.classList.contains("etablissement-visible")) {
                aurayListe.classList.remove("etablissement-visible");
            }
        });
        lorientClose.addEventListener("click", function () {
            lorientListe.classList.remove("etablissement-visible");
        });

        // Auray
        aurayPin.addEventListener("click", function () {
            aurayListe.classList.toggle("etablissement-visible");

            if (vannesListe.classList.contains("etablissement-visible")) {
                vannesListe.classList.remove("etablissement-visible");
            }
            if (lorientListe.classList.contains("etablissement-visible")) {
                lorientListe.classList.remove("etablissement-visible");
            }
        });
        aurayClose.addEventListener("click", function () {
            aurayListe.classList.remove("etablissement-visible");
        });

        // Vannes
        vannesPin.addEventListener("click", function () {
            vannesListe.classList.toggle("etablissement-visible");

            if (lorientListe.classList.contains("etablissement-visible")) {
                lorientListe.classList.remove("etablissement-visible");
            }
            if (aurayListe.classList.contains("etablissement-visible")) {
                aurayListe.classList.remove("etablissement-visible");
            }
        });
        vannesClose.addEventListener("click", function () {
            vannesListe.classList.remove("etablissement-visible");
        });
    }

    /*=============================================>>>>>
    = Animations Plan du site =
    ===============================================>>>>>*/
    function planDuSite() {
        document.querySelector("#showPlan").addEventListener("click", function (e) {
            e.preventDefault();
            var linkks = document.querySelectorAll(".tosee");
            Array.prototype.forEach.call(linkks, function (link) {
                link.classList.toggle("tosee-visible");
            });
        });
    }

    /*=============================================>>>>>
    = Ajout span dans li selecteur de marques forms
    ===============================================>>>>>*/
    function wrapLis() {
        jQuery("#wpforms-1032-field_31,#wpforms-1069-field_30")
            .find("li")
            .each(function () {
                jQuery(this).wrapInner("<span></span>");
            });
    }


    // Page d'accueil
    jQuery('div.card-cell').removeClass('d-none');

    // Page de détail d'un véhicule
    let carousel = jQuery('.single-vehicule__galerie.flickity');
    if( carousel != null ) {
        carousel.flickity({
            "contain": true,
            "pageDots": true,
            "wrapAround": true,
            "cellAlign": "left",
            "autoPlay": 2000,
            "prevNextButtons": true,
            "pauseAutoPlayOnHover": true,
            "lazyLoad": true
        });
        carousel.flickity('pausePlayer');
        setTimeout(function () {
            carousel.flickity('unpausePlayer');
        }, 4000);
    }


    // Video
    let v = document.querySelector("#video");
    if (v) {
        v.play();
    }

    // Collapse recherche mobile Homepage
    jQuery("#collapse_recherche").click(() => {
        jQuery("#recherche_mobile").show();
    });
    jQuery(document).on("click", "#close_recherche", () => {
        jQuery("#recherche_mobile").hide();
    });

    // Collapse recherche mobile Trouver son véhicule
    jQuery("#collapse_recherche_trouver_vehicule").click(() => {
        jQuery("#recherche_trouver_vehicule").toggle();
    });
    jQuery(document).on("click", "#close_recherche_trouver_vehicule", () => {
        jQuery("#recherche_trouver_vehicule").toggle();
    });
    jQuery(document).on("click", "#go_close_recherche", (e) => {
        e.preventDefault();
        jQuery("#recherche_trouver_vehicule").toggle();
        window.location.href = "/trouver-son-vehicule/#content";
    });

    // Collapse Recherche Location mobile
    jQuery("#collapse_recherche_louer_vehicule").click(() => {
        jQuery("#recherche_louer_vehicule").toggle();
        jQuery("#wrapper-navbar").toggle();
    });
    jQuery(document).on("click", "#close_recherche_louer_vehicule", () => {
        jQuery("#recherche_louer_vehicule").toggle();
        jQuery("#wrapper-navbar").toggle();

    });

    /// Collapse tri Page équipes, actus et établissements
    jQuery(".collapse-tri").on("click", () => {
        if (window.innerWidth <= 991) {
            jQuery("#tri-marques").slideUp();
            jQuery("#etablissement-list").slideToggle();
            jQuery("#categories-list").slideToggle();
            jQuery("#tri-etablissements").slideToggle();
            // jQuery(".collapse-tri").find("svg").toggleClass("rotate");
        }
    });

    //Page établissements
    jQuery(".collapse-marques").on("click", () => {
        if (window.innerWidth <= 991) {
            jQuery("#tri-etablissements").slideUp();
            jQuery("#tri-marques").slideToggle();
        }
    });
    jQuery("#tri-etablissements li").on("click", () => {
        window.innerWidth <= 991 ? jQuery("#tri-etablissements").slideUp() : "";
    });
    jQuery(".marque--item").on("click", () => {
        window.innerWidth <= 991 ? jQuery("#tri-marques").slideUp() : "";
    });


    //Filtre mobile page equipe
    jQuery(".etablissement").on("click", () => {
        if (window.innerWidth <= 991) {
            jQuery("#liste-etablissements").toggleClass("d-flex");
        }
    });

    jQuery("#liste-etablissements .etablissement-list_item").on("click", function () {
        if (window.innerWidth <= 991) {
            jQuery("#liste-etablissements").toggleClass("d-flex");
        }
    });

    //Filtre mobile page actus
    jQuery(".actus").on("click", () => {
        jQuery("#categories-list-mobile").toggleClass("d-flex");
    });

    jQuery("#categories-list-mobile .cat-list_item").on("click", function () {
        jQuery("#categories-list-mobile").toggleClass("d-flex");
    });

    /*=============================================>>>>>
    =  Formulaire page intervention
    ===============================================>>>>>*/
    wrapLis();

    /*=============================================>>>>>
    = Isotope page ETABLISSEMENT - TRI PAR VILLE
    ===============================================>>>>>*/
    let mycontainerEtablissement = jQuery("#etablissement_isotope");
    mycontainerEtablissement.isotope({
        itemSelector: ".grid-item",
        percentPosition: true,
    });
    jQuery("#tri-etablissements li").click(function () {
        let selector = jQuery(this).attr("data-filter");
        jQuery(this).addClass("active");
        if (
            jQuery("#tri-etablissements li")
                .siblings("#tri-etablissements li")
                .hasClass("active")
        ) {
            jQuery(this).siblings("#tri-etablissements li").removeClass("active");
        }
        mycontainerEtablissement.isotope({filter: selector});
        return false;
    });

    /*=============================================>>>>>
    = Isotope page ETABLISSEMENT -- TRI PAR MARQUES
    ===============================================>>>>>*/
    let mycontainerMarque = jQuery("#etablissement_isotope");
    mycontainerMarque.isotope({
        itemSelector: ".grid-item",
        percentPosition: true,
    });
    jQuery(".marque").click(function () {
        let selector = jQuery(this).attr("data-filter");
        jQuery(this).addClass("active");
        if (jQuery(".marque").siblings(".marque").hasClass("active")) {
            jQuery(this).siblings(".marque").removeClass("active");
        }
        mycontainerMarque.isotope({filter: selector});
        return false;
    });

    /*=============================================>>>>>
    = Isotope Descriptif details véhicule
    ===============================================>>>>>*/
    // var optLimitUl = jQuery("#opt_limit").find("ul");
    // jQuery("a[data-toggle=tab]").each(function () {
    //     var $this = jQuery(this);
    //
    //     $this.on("shown.bs.tab", function () {
    //         optLimitUl.imagesLoaded(function () {
    //             optLimitUl.masonry({
    //                 columnWidth: "li",
    //                 itemSelector: "li",
    //                 gutter: 15,
    //             });
    //         });
    //     });
    // });
    jQuery("a[data-toggle=tab]").on("shown.bs.tab", function () {
        let optLimitUl = jQuery("#opt_limit").find("ul");
        optLimitUl.imagesLoaded(function () {
            optLimitUl.masonry({
                columnWidth: "li",
                itemSelector: "li",
                gutter: 15,
            });
        });
    });

    // Garage score
    // setTimeout(function () {
    //     jQuery(".rank").flickity({
    //         cellAlign: "center",
    //         contain: true,
    //         prevNextButtons: false,
    //         pageDots: false,
    //         autoPlay: true,
    //         autoPlay: 1500,
    //         pauseAutoPlayOnHover: true,
    //     });
    //     // jQuery(".fullclickable").each(function () {
    //     //     jQuery(this).find("a").css({
    //     //         margin: "auto",
    //     //     });
    //     //     jQuery("#respondentsCount").remove();
    //     // });
    //     jQuery(".fullclickable a").css({
    //             margin: "auto",
    //         });
    //     jQuery(".fullclickable #respondentsCount").remove();
    // }, 1000);

    // Init etablissementsCollapse
    etablissementsCollapse();

    // Init fixed-menu
    stickyNavbar();

    // Init plan du site
    planDuSite();

    /*=============================================>>>>>
    = Cards modal page FINANCEMENT =
    ===============================================>>>>>*/
    function avantagesCards() {
        // let cardToClick = jQuery(".js-avantage-show");
        // cardToClick.each(function () {
        //     let visibleClass = "text-to-collapse--is-visible";
        //     var clicked = false;
        //     //OPEN
        //     jQuery(this).on("click", function () {
        //         jQuery(this).find(".text-to-collapse").addClass(visibleClass);
        //         jQuery("body").css("overflow", "hidden");
        //         clicked = true;
        //     });
        //     //CLOSE
        //     let closeBut = jQuery(".close"); // .close
        //     closeBut.each(function () {
        //         // console.log(jQuery(this).parent());
        //         jQuery(document).on("click", ".close", function () {
        //             jQuery(this).parent().removeClass("text-to-collapse--is-visible");
        //             jQuery("body").css("overflow", "auto");
        //         });
        //     });
        // });

        //OPEN
        jQuery(".js-avantage-show").on("click", function (e) {
            e.preventDefault();
            jQuery(this).find(".text-to-collapse").addClass("text-to-collapse--is-visible");
            jQuery("body").css("overflow", "hidden");
        });
        //CLOSE
        jQuery(".js-avantage-show .close").on("click", function (e) {
            e.preventDefault();
            jQuery(this).parent().removeClass("text-to-collapse--is-visible");
            jQuery("body").css("overflow", "auto");
            e.stopPropagation();
        });
    }
    avantagesCards();

    // Tooltips
    jQuery('[data-toggle="tooltip"]').tooltip();
    jQuery.fn.bstooltip = jQuery.fn.tooltip.noConflict();

    // COLLAPSE HORAIRES
    function horairesCards() {
        // let cardToClick = jQuery(".horaires-etablissements");
        // cardToClick.each(function () {
        //     //OPEN
        //     jQuery(".collapse-horaires").on("click", function (e) {
        //         e.preventDefault();
        //         jQuery(this)
        //             .parent()
        //             .next(".horaires-etablissements")
        //             .css("display", "flex");
        //     });
        //     //CLOSE
        //     let closeBut = jQuery(".close"); // .close
        //     closeBut.each(function () {
        //         // console.log(jQuery(this).parent());
        //         jQuery(document).on("click", ".close", function () {
        //             jQuery(this).parent().parent().css("display", "none");
        //         });
        //     });
        // });

        //OPEN
        jQuery(".horaires-etablissements .collapse-horaires").on("click", function (e) {
            e.preventDefault();
            jQuery(this).parent().next(".horaires-etablissements").css("display", "flex");
        });
        //CLOSE
        jQuery(".horaires-etablissements .close").on("click", function (e) {
            e.preventDefault();
            jQuery(this).parent().parent().css("display", "none");
            e.stopPropagation();
        });
    }
    horairesCards();

    // Affichage des avis complets
    function avisComplet() {

        //OPEN
        jQuery(".rplg-more-toggle").on("click", function (e) {
            e.preventDefault();
            jQuery(this).parent().next(".rplg-more").css("visibility", "visible");
        });

        //CLOSE
        jQuery(".rplg-more .close").on("click", function (e) {
            e.preventDefault();
            jQuery(this).parent().css("visibility", "hidden");
            e.stopPropagation();
        });

    }
    avisComplet();

    //WPForm Rdv essai véhicule neuf
    //on recupere le select
    //on recupère la marque
    //si marque n'est pas dans l'option value, on display none
    let marqueVehiculeNeuf = jQuery("#marque").data("name");
    jQuery("#wpforms-125669-field_1 option").map(function () {
        if (jQuery(this).val().indexOf(marqueVehiculeNeuf) === -1) {
            jQuery(this).addClass("d-none");
        }
    });

    let marque = jQuery("#wpforms-125669-field_45");
    if (marqueVehiculeNeuf) {
        jQuery(marque).val(marqueVehiculeNeuf);
    }

    let modeleVehiculeNeuf = jQuery("#modele").data("name");
    let modele = jQuery("#wpforms-125669-field_46");
    if (modeleVehiculeNeuf) {
        jQuery(modele).val(modeleVehiculeNeuf);
    }
    // FIN READY

    /*=============================================>>>>>
    = Back button =
    ===============================================>>>>>*/
    let backbutton = document.getElementById("backbut");
    let windowHeight = window.innerHeight;
    function scrollFunction(event) {
        if (
            document.body.scrollTop > windowHeight ||
            document.documentElement.scrollTop > windowHeight
        ) {
            backbutton.classList.add("visible");
        } else {
            backbutton.classList.remove("visible");
        }

        
        const $stepsTimeline = document.querySelector('#steps-timeline');
        if ($stepsTimeline) {
            debounce(onStepsTimelineScroll($stepsTimeline, event), 1000);
        }

        const $stepsTimelineCar = document.querySelector('#steps-timeline-with-car');
        if ($stepsTimelineCar) {
            debounce(onStepsTimelineCarScroll($stepsTimelineCar, event), 1000);
        }
    }

    function debounce(func, timeout = 300){
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }
    
    let onStepsTimelineScrollClosestIndex = 0;
    function onStepsTimelineScroll ($stepsTimeline, event) {
        const centerPosition = parseInt(window.innerHeight/2);
        const $steps = Array.from($stepsTimeline.querySelectorAll('.step'));
        const stepsPosition = $steps.map(($step, index) => {
            return {
                index: index,
                element: $step,
                position: parseInt($step.getBoundingClientRect().top)
            }
        });
        const closest = stepsPosition.reduce((a, b) => {
            return Math.abs(b.position - centerPosition) < Math.abs(a.position - centerPosition) ? b : a;
        });
        if (closest.index !== onStepsTimelineScrollClosestIndex) {
            onStepsTimelineScrollClosestIndex = closest.index;
            $steps.forEach(($step) => $step.classList.remove('step--highlighted'));
            closest.element.classList.add('step--highlighted');
        }
    }

    let onStepsTimelineCarScrollClosestIndex = -1;
    let carOffsetTopDelay = 150;
    function onStepsTimelineCarScroll ($stepsTimelineCar, event) {
        if ($stepsTimelineCar.querySelector('#steps-timeline-car').offsetTop > carOffsetTopDelay) {
            const $car = $stepsTimelineCar.querySelector('#steps-timeline-car');
            const carPosition = $car.getBoundingClientRect().top + ($car.offsetHeight/2);
            const $steps = Array.from($stepsTimelineCar.querySelectorAll('.step'));
            const stepsPosition = $steps.map(($step, index) => {
                return {
                    index: index,
                    element: $step,
                    position: parseInt($step.getBoundingClientRect().top)
                }
            });
            const closest = stepsPosition.reduce((a, b) => {
                return Math.abs(b.position - carPosition) < Math.abs(a.position - carPosition) ? b : a;
            });
            if (closest.index !== onStepsTimelineCarScrollClosestIndex) {
                onStepsTimelineCarScrollClosestIndex = closest.index;
                $steps.forEach(($step) => $step.classList.remove('step--highlighted'));
                closest.element.classList.add('step--highlighted');
            }
        }
    }

    // When the user clicks on the button, scroll to the top of the document
    backbutton.onclick = function (e) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };


    // SCROLL EVENTS
    window.addEventListener('scroll', (event) => {
        debounce(stickyNavbar(), 1000);
        scrollFunction(event);
    });

    //  CHIFFRES ANIMES
    jQuery(window).scroll(chiffresScroll);
    let viewed = false;
    function isScrolledIntoView(elem) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();

        if (jQuery(elem).offset() != undefined) {
            var elemTop = jQuery(elem).offset().top;
        }
        var elemBottom = elemTop + jQuery(elem).height();

        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
    function chiffresScroll() {
        if (isScrolledIntoView(jQuery(".avis")) && !viewed) {
            viewed = true;
            jQuery(".avis__count,.chiffres-cles__number").each(function () {
                jQuery(this)
                    .prop("Counter", 0)
                    .animate(
                        {
                            Counter: jQuery(this).text(),
                        },
                        {
                            duration: 4000,
                            easing: "swing",
                            step: function (now) {
                                jQuery(this).text(Math.ceil(now));
                            },
                        }
                    );
            });
        }
    }

    //RGPD MAILJET
    let mailjet = jQuery("#mailjet_widget_email");
    mailjet.focus(function () {
        var rgpd = jQuery("#rgpd_mailjet");
        rgpd.removeClass("d-none");
    });
    mailjet.focusout(function () {
        var rgpd = jQuery("#rgpd_mailjet");
        rgpd.addClass("d-none");
    });


    //Fix IOS zoom quand font-size < 16px dans les input, select
    const addMaximumScaleToMetaViewport = () => {
        const el = document.querySelector('meta[name=viewport]');

        if (el !== null) {
            let content = el.getAttribute('content');
            let re = /maximum\-scale=[0-9\.]+/g;

            if (re.test(content)) {
                content = content.replace(re, 'maximum-scale=1.0');
            } else {
                content = [content, 'maximum-scale=1.0'].join(', ')
            }
            el.setAttribute('content', content);
        }
    };
    const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;
    // /programming/9038625/detect-if-device-is-ios/9039885#9039885
    const checkIsIOS = () =>
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (checkIsIOS()) {
        disableIosTextFieldZoom();
    }

    //Formulaire de contact par téléphone (page détails annonce)
    let ctaFormTel = document.getElementById("ctaFormTel");
    if (ctaFormTel) {
        ctaFormTel.addEventListener("click", function (e) {
            e.preventDefault();
            document.getElementById("formTel").classList.toggle("d-none");
        });
    }

    let ctaNumConcession = document.getElementById("ctaNumConcession");
    if (ctaNumConcession) {
        ctaNumConcession.addEventListener("click", function (e) {
            e.preventDefault();
            document.getElementById("numConcession").classList.toggle("d-none");
            ctaNumConcession.classList.toggle("d-none");
        });
    }

    // Scrolls de la page Reprise
    jQuery('#div-argus').on('shown.bs.collapse', function () {
        jQuery("html").animate(
            {
                scrollTop: jQuery("#div-argus").offset().top - 100
            },
            800 //speed
        );
    })
    jQuery('#div-click2sell').on('shown.bs.collapse', function () {
        jQuery("html").animate(
            {
                scrollTop: jQuery("#div-click2sell").offset().top - 100
            },
            800 //speed
        );
    })

    // let livraison = jQuery('textarea[name=mode_livraison]');
    // if( livraison ) {
    //     livraison.html( livraison.val().split("&").join('\n') );
    // }
    let livraisons = document.getElementsByName("mode_livraison");
    if( livraisons.length ) {
        livraisons[0].value = livraisons[0].value.split("&").join('\n');
    }

    // Tweak menu to have dropdown menu on hover
    function hoverNavbarDropdownMenu () {
        const $dropdownMenu = document.querySelector('#navbarv2-left-menu');
        if ($dropdownMenu) {
            const dropdownToggles = Array.from($dropdownMenu.querySelectorAll('.nav-link'));
            
            if(dropdownToggles.length) {
                dropdownToggles.forEach(($dropdownToggle) => {
                    let dropdownHoverTimeout = null;
                    const $dropdownMenu = $dropdownToggle.parentElement.querySelector('.dropdown-menu');

                    $dropdownToggle.addEventListener('mouseenter', (event) => {
                        event.stopPropagation();
                        clearTimeout(dropdownHoverTimeout);
                        dropdownHoverTimeout = setTimeout(() => {
                            if ($dropdownToggle.classList.contains('dropdown-toggle')) {
                                if (!$dropdownMenu.classList.contains('show')) {
                                    jQuery($dropdownToggle).trigger('click');
                                }
                            } else {
                                jQuery(document.body).trigger('click');
                            }
                        }, 500);
                    });

                    $dropdownToggle.addEventListener('mouseleave', (event) => {
                        event.stopPropagation();
                        clearTimeout(dropdownHoverTimeout);
                    });

                    $dropdownToggle.addEventListener('click', (event) => {
                        if ($dropdownToggle.classList.contains('dropdown-toggle') && $dropdownMenu.classList.contains('show')) {
                            if ($dropdownToggle.title && $dropdownToggle.title.includes('http')) {
                                event.preventDefault();
                                event.stopPropagation();
                                document.location.href = $dropdownToggle.title;
                            }
                        }
                    });
                })
            }
        }
    }

    if (!isMobile()) {
        hoverNavbarDropdownMenu();
    }

    // Scroll to item
    const goToLinks = Array.from(document.querySelectorAll('[data-scrollto-target]'));
    if (goToLinks) {
        goToLinks.forEach(($goToLink) => {
            $goToLink.addEventListener('click', (e) => {
                e.preventDefault();
                const $target = document.querySelector($goToLink.dataset.scrolltoTarget);
                if ($target) {
                    jQuery([document.documentElement, document.body]).animate({
                        scrollTop: $target.offsetTop - jQuery('.navbarv2').height() - 10
                    }, 500);
                }
            });
        });
    }

    // Scroll to collapse item
    const goToCollapseLinks = Array.from(document.querySelectorAll('[data-scrollto-collapse-target]'));
    if (goToCollapseLinks) {
        goToCollapseLinks.forEach(($goToLink) => {
            $goToLink.addEventListener('click', (e) => {
                e.preventDefault();
                const $header = jQuery($goToLink.dataset.scrolltoCollapseHeader);
                const $collapse = jQuery($goToLink.dataset.scrolltoCollapseTarget);
                if ($header.length) {
                    jQuery([document.documentElement, document.body]).animate({
                        scrollTop: $header.offset().top - jQuery('.navbarv2').height() - 100
                    }, 500, () => {
                        $collapse.collapse('show');
                    });
                }
            });
        });
    }

    if (document.body.classList.contains('blog-template') && document.querySelector('.sld-blog-link-list')) {
        const anchorLinks = document.querySelectorAll('a[href^="#"]');
        if (anchorLinks) {
            anchorLinks.forEach($anchor => {
                $anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    anchorLinks.forEach((a) => a.classList.remove('active'));
                    $anchor.classList.add('active');
    
                    const $target = document.querySelector($anchor.getAttribute('href'));
                    if ($target) {
                        jQuery([document.documentElement, document.body]).animate({
                            scrollTop: jQuery($target).offset().top - jQuery('.navbarv2').height() - 50
                        }, 500);
                    }
                });
            });
        }
    }
});
